export default __webpack_public_path__ + "static/media/coin_btc.4a4670d0.svg";